export enum CheckInsGroupsOptions {
  NONE = "None",
  CHECK_IN_ID = "Check-in ID"
}
